import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from '../developers/page-components/WhisperComponent';

interface IFieldInput {
	key: string;
	fieldName: string;
	firstField: boolean;
	symbolCode?: boolean;
	percentage?: boolean;
}

interface IField {
	title: string;
	input: IFieldInput | null;
	description?: string;
}

interface IElement {
	items: IField[]
}

interface IConfigurationFieldsProps {
	formik: any;
	isEditMode?: boolean;
	elem: IElement;
}

export const ConfigurationFields = (props: IConfigurationFieldsProps): JSX.Element => {
	const { formik, isEditMode, elem } = props;
	const fields = elem.items;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>, percentage: boolean, fieldName: string): void => {
		if (e.target.value) {
			let value = Math.abs(Number(e.target.value));

			if (percentage && (value > 100)) {
				value = value - (value - 100);
			}
			formik.setFieldValue(fieldName, value || 0);
		} else {
			formik.setFieldValue(fieldName, undefined);
		}
	};

	return (
		<div className="d-flex align-items-center mb-3">
			{
				fields.map((item: IField, index) => {
					const { title,description, input }= item;

					return (
						<React.Fragment key={`${title} - ${index}`}>
							<div className={clsx(input?.firstField ? 'w-300px' : 'ms-2 me-2')}>
								<span className={clsx(!isEditMode && 'text-muted')}>{title}</span>
								{input?.firstField && (
									<WhisperComponent
										isTooltip
										whisperText={description}
										mainText={
											<FontAwesomeIcon
												icon={faQuestionCircle}
												className={clsx('cursor-pointer ms-1', !isEditMode && 'text-muted')}
												width={12}
											/>
										}
									/>
								)}

							</div>
							{
								input && (
									<div className={clsx('fee-input-container', isEditMode && 'isEditBG')}>
										{input?.symbolCode && (
											<div>
												$
											</div>
										)}
										<input
											type="number"
											className={clsx('number-input', !input?.percentage && 'w-65px')}
											disabled={!isEditMode}
											{...formik.getFieldProps(input?.fieldName)}

											onChange={(e): void => handleChange(e, input?.percentage, input?.fieldName)}
										/>
										{input?.percentage && (
											<div>
												%
											</div>
										)}
									</div>
								)
							}
							<div className="error-container h-20px">
								<div className="text-danger fs-8">
									{formik.touched[input?.fieldName] && formik.errors[input?.fieldName]}
								</div>
							</div>
						</React.Fragment>
					);
				})
			}
		</div>

	);
};
